const defaultPageRows = [5, 10, 15, 25, 50, 100];
const additionalRows_500 = [200, 300, 400, 500];
const additionalRows_400 = [200, 300, 400];
const additionalRows_300 = [200, 300];
const additionalRows_200 = 200;
export function getCustomPageRowsNumbers(dataLength) {
    let customPageRowNumbers = [];
    //push default rows
    defaultPageRows.forEach((num) => customPageRowNumbers.push(num));
    if (dataLength == 0) {
        return customPageRowNumbers;
    }
    //push remaining limits based on data length
    if (dataLength > 400 && dataLength <= 500) {
        additionalRows_500.forEach((num) => customPageRowNumbers.push(num));
    }
    else if (dataLength > 300 && dataLength <= 400) {
        additionalRows_400.forEach((number) => customPageRowNumbers.push(number));
    }
    else if (dataLength > 200 && dataLength <= 300) {
        additionalRows_300.forEach((number) => customPageRowNumbers.push(number));
    }
    else if (dataLength > 100 && dataLength <= 200) {
        customPageRowNumbers.push(additionalRows_200);
    }
    if (dataLength > 500) {
        additionalRows_500.forEach((number) => customPageRowNumbers.push(number));
        customPageRowNumbers.push(dataLength);
    }
    return customPageRowNumbers;
}
